module.exports = __webpack_public_path__ + "/img/Radial-Led-Round-cNqR4H.svg";